import { AbstractControl, ValidationErrors } from "@angular/forms";
import { ReportsFormComponent } from "./reports-form.component";

/**
 * Pollux form validators
 */
export class ReportsValidators {

  /**
   * Validates the template
   * @returns
   */
  static template() {
    return (form: ReportsFormComponent) => {
      return (control: AbstractControl): ValidationErrors | null => {
        try {
          if (form.formReady && form.formData) {
            const templateId = control.value;
            const languageId = control.parent.controls['languageDefinitionId'].value;
            const templates = form.availableTemplates.filter((tmp) => { return tmp.templateLanguages.indexOf(languageId) >= 0; });
            const templateMatchesLanguage = templateId === 0 || templates.find((tmp) => { return tmp.Oid === templateId; });
            if (templateMatchesLanguage) {
              return null;
            }
            else {
              return { 'invalidLanguageAndTemplate': true };
            }
          }
        } catch (e) {
          //Not ready - ignore
        }
        return null;
      };
    }
  }
}
